import React from 'react';
import PropTypes from 'prop-types';
import { devNote } from '@xingternal/malt-util';
import { IconWithBadge } from '@xingternal/platform-layout-icon-with-badge';
import { RingingBell } from './RingingBell';
import styles from './IconComponent.css';
/**
 * Are new notifications present?
 */
const hasNewNotifications = (count) => {
    if (count === 0) {
        return false;
    }
    try {
        const storedCount = global.sessionStorage.getItem('nc-count');
        const storedNumber = Number(storedCount);
        // Set default state (or overwrite any wrong value)
        if (storedCount === null || Number.isInteger(storedNumber)) {
            global.sessionStorage.setItem('nc-count', count);
        }
        // Known blind spot: the amount of new notifications are the same as the stored ones.
        // Based on the counted, we can't tell if they're new or the same ones.
        if (count === storedNumber) {
            return false;
        }
        // If NC counts are different, bell should ring
        return true;
    }
    catch (error) {
        devNote.warn(error);
    }
};
const IconComponent = ({ isActive, icon, activeIcon, count }) => {
    /* Only animate when:
     * - featureSwitch is present,
     * - counts are present
     * - NC Counter are updated,
     * - we're not on Notification Center app
     */
    const isAnimated = count > 0 && hasNewNotifications(count);
    const bellIcon = isActive ? activeIcon : isAnimated ? RingingBell : icon;
    return (React.createElement(IconWithBadge, { icon: bellIcon, count: count, className: styles.bellIcon }));
};
IconComponent.propTypes = {
    count: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
    activeIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
        .isRequired,
};
export { IconComponent };
//# sourceMappingURL=IconComponent.js.map